// extracted by mini-css-extract-plugin
export default {"edit_mainCont":"DeleteAccount_edit_mainCont__4RmD1"};